import React from 'react';
import { Modal } from 'react-bootstrap';

export default (props) => (
  <Modal
    className="team-confirm-delete-modal"
    show={props.open}
    onHide={() => props.onClose()}
  >
    <Modal.Header closeButton>
      {props.mode === 'all' && <Modal.Title>DELETE OR ARCHIVE</Modal.Title>}
      {props.mode === 'delete' && <Modal.Title>DELETE</Modal.Title>}
      {props.mode === 'recover' && <Modal.Title>RECOVER</Modal.Title>}
    </Modal.Header>
    <Modal.Body>
      <div className="team-confirm-delete-modal-body text-center">
        {props.mode === 'all' && (
          <strong>
            Are you sure you want to delete or archvie this team?
            <br />
            Deleting a team cannnot be undone.
          </strong>
        )}
        {props.mode === 'delete' && (
          <strong>
            Are you sure you want to delete? Deleting a team cannnot be undone.
          </strong>
        )}
        {props.mode === 'recover' && (
          <strong>Are you sure you want to recover this team?</strong>
        )}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <div className="modal-footer-buttons">
        <button
          className="btn-secondary cancel"
          onClick={() => props.onClose()}
        >
          Cancel
        </button>

        {props.mode === 'all' && (
          <button className="btn-danger" onClick={() => props.delete()}>
            Delete
          </button>
        )}
        {props.mode === 'all' && (
          <button className="btn-danger" onClick={() => props.archive()}>
            Archive
          </button>
        )}

        {props.mode === 'delete' && (
          <button className="btn-danger" onClick={() => props.delete()}>
            Delete
          </button>
        )}
        {props.mode === 'recover' && (
          <button className="btn-danger" onClick={() => props.recover()}>
            Recover
          </button>
        )}
      </div>
    </Modal.Footer>
  </Modal>
);



// WEBPACK FOOTER //
// src/components/Teams/DeleteConfrimModal.jsx